import React from 'react';
import styled from 'styled-components';
import { globalTheme } from '@clds/component-theme';
import { withTextSkeleton } from '@cld/skeleton';
import { adjustHue } from 'utils/colorUtils';

const TextWithSkeleton = withTextSkeleton(styled.span``);

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  background-color: ${(props) => adjustHue(props.theme.color.sourceBg)}; // TODO: for future create new component theme (for app) and consume it instead
  position: absolute;
  top: 0;
  left: 0;
  padding: ${globalTheme.spacing.sm};
`;

const TextWrapperTop = styled.div`
  height: 14px;
  width: 20%;
`;

const TextWrapperBottom = styled(TextWrapperTop)`
  width: 80% !important;
  margin-top: ${globalTheme.spacing.xs};
`;

const GridTileSkeleton = () => (
  <Wrapper>
    <TextWrapperTop>
      <TextWithSkeleton isLoading />
    </TextWrapperTop>
    <TextWrapperBottom>
      <TextWithSkeleton isLoading />
    </TextWrapperBottom>
  </Wrapper>
);

export default GridTileSkeleton;
